import React from 'react'

import styled from 'styled-components'

import { Spacer, Paragraph, Button } from '@client/components'
import { Modal, ModalFormContainer } from '@client/components/molecules'
import { ModalActionContainer } from '@client/components/Theme'

const ActionContainer = styled.div`
  ${ModalActionContainer()}
`
export interface GenericMessageModalProps {
  title: string
  message: string
  primaryActionText: string
  secondaryActionText?: string
  maxWidth?: string
  minWidth?: string

  headerContainerPadding?: string
  open?: boolean
  onPrimaryAction: () => void
  onSecondaryAction?: () => void
  onClose: () => void
}

export function GenericMessageModal({
  title,
  message,
  primaryActionText,
  secondaryActionText = 'Cancel',
  open = false,
  onPrimaryAction,
  onSecondaryAction,
  onClose,
  maxWidth,
  minWidth,
  headerContainerPadding,
}: GenericMessageModalProps): JSX.Element {

  const _handleClose = (): void => {
    onClose?.()
  }

  const _handlePrimaryActionClicked = () => {
    onPrimaryAction?.()
  }

  const _handleSecondaryActionClicked = () => {
    // If a specific secondary action handler is provided, use it. Otherwise, default to closing the modal.
    if (onSecondaryAction) {
      onSecondaryAction()
    } else {
      _handleClose()
    }
  }

  return (
    <Modal
      open={open}
      fullscreen={false}
      title={title}
      maxWidth={maxWidth}
      minWidth={minWidth}
      headerContainerPadding={headerContainerPadding}
      showCloseButton
      onClose={_handleClose}>
      <ModalFormContainer className='form-container'>
        <Paragraph variant='p1' align='center'>{message}</Paragraph>
        <Spacer universal='32px' />
        <ActionContainer>
          <Button color='black' fullWidth title={primaryActionText} onClick={_handlePrimaryActionClicked} />
          <Spacer universal='16px' />
          {/* <Link variant='l2' decoration='underline' onClick={_handleSecondaryActionClicked}> {secondaryActionText} </Link> */}
          <Button color='black' variant='secondary' fullWidth title={secondaryActionText} onClick={_handleSecondaryActionClicked} />
        </ActionContainer>
      </ModalFormContainer>
    </Modal>
  )
}
